module.exports = __webpack_public_path__ + "static/media/7.8d7cef55.png";